// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"CancelButton_cancelButton__1gsQ8"};